import { render, staticRenderFns } from "./tcontractconfig.vue?vue&type=template&id=6e8ff76f&"
import script from "./tcontractconfig.vue?vue&type=script&lang=js&"
export * from "./tcontractconfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports